import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";

const ErrorPage: React.FC = () => (
  <Container className="d-flex vh-100">
    <Row className="m-auto align-items-center">
      <Col md={8} className="mx-auto text-center">
        <h1 className="display-4">Oops!</h1>
        <p className="lead">There was an error processing your request.</p>
        <Button variant="outline-primary" href="/">
          Go Home
        </Button>
      </Col>
    </Row>
  </Container>
);

export default ErrorPage;
